// src/i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCN from '../lang/zh-CN.js';
import en from '../lang/en.js';
import zhTW from '../lang/zh-TW.js';
import ja from '../lang/ja.js';

Vue.use(VueI18n);

const messages = {
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'en': en,
    'ja': ja
};

let lang = 'zh-CN'
try {
    const storedLang = window.localStorage.getItem('lang')
    if (storedLang) lang = storedLang
} catch (e) {
    console.warn('localStorage unavailable in WebView:', e)
}

const i18n = new VueI18n({
    // set locale 默认显示英文
    locale: lang,
    fallbackLocale: 'en',
    messages,
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    // 👇 这行是关键：禁用动态 message 编译
    formatter: {
        interpolate(message, values) {
            // 简单实现一个静态插值器
            if (!values) return [message]
            return [message.replace(/\{(\w+)\}/g, (_, key) => values[key] ?? '')]
        }
    }
});

export default i18n;
